import { createFileRoute } from '@tanstack/react-router';
import { TabPlaceholder } from '@/features/creators/dashboard/components/tab-placeholder';
import { PLACEHOLDER_TEXT } from '@/features/creators/dashboard/content';

// /ixi-finance/creators/dashboard/itinerary — placeholder until the Itinerary tab is built.
export const Route = createFileRoute(
	'/_auth/ixi-finance/creators_/dashboard/itinerary',
)({
	component: () => <TabPlaceholder title={PLACEHOLDER_TEXT.itineraryTitle} />,
});
